/**
 * Graphics presets. Each one trades rendering cost for detail; none of them
 * changes anything the simulation sees.
 *
 * The numbers were chosen from measurements on real GPUs (docs/PERFORMANCE.md,
 * tests/hw/graphicsBench.mjs), not assumed.
 */
import type { GraphicsQuality } from '../ui/Settings';

export interface QualityProfile {
  /** MSAA on the default framebuffer (fixed when the renderer is created). */
  antialias: boolean;
  /** Upper bound on the device pixel ratio (before the render-scale setting). */
  maxPixelRatio: number;
}

export const QUALITY: Readonly<Record<GraphicsQuality, Readonly<QualityProfile>>> = {
  low: { antialias: false, maxPixelRatio: 1 },
  medium: { antialias: true, maxPixelRatio: 1.5 },
  high: { antialias: true, maxPixelRatio: 2 },
};

